module.exports = __webpack_public_path__ + "media/knock.12189a0e.wav";